class Colleges {
    constructor() {
        this.addListeners()
        this.addMap()
    }

    addListeners() {
        const topten = document.getElementById('topten')
        const territory = document.getElementById('territoryHeader')
        const directions = document.getElementById('directionsBlock')
        const showColleges = document.getElementById('showMoreColleges')
        const tableButtons = document.querySelectorAll('.showmore-button--table')

        tableButtons.forEach(btn => {
            btn.addEventListener('click', (e) => {
                const tableId = 'table-' + e.target.id
                const table = document.getElementById(tableId)
                const rows = table.querySelectorAll('.sutable-row--hidden')

                rows.forEach(row => {
                    row.classList.remove('sutable-row--hidden')
                    row.classList.add('sutable-row')
                })

                e.target.style.display = 'none'
            })
        })

        if (showColleges) {

            showColleges.addEventListener('click', () => {
                const hiddenColleges = document.querySelectorAll('.colleges-list--hidden')
                showColleges.style.display = 'none'
                hiddenColleges.forEach(college => {
                    college.classList.remove('colleges-list--hidden')
                })
            })

        }

        if (directions) {
            directions.addEventListener('click', () => {
                directions.classList.toggle('directions-wrapper--hidden')
            })
        }

        if (territory) {
            const list = document.getElementById('territoryList')
            const arrow = territory.querySelector('.territory__arrow')

            territory.addEventListener('click', (e) => {
                list.classList.toggle('territory--hidden')
                arrow.classList.toggle('territory__arrow--up')
            })
        }

        if (topten) {
            const arrow = topten.querySelector('.topten-arrow')
            const items = topten.querySelectorAll('.topten-item--hide')

            arrow.addEventListener('click', () => {
                items.forEach(item => {
                    item.classList.toggle('topten-item--hidden')
                })

                arrow.classList.toggle('topten-arrow--down')
            }) 
        }
    }

    addMap() {

        const collegeMap = document.getElementById('collegeMap')


        if (collegeMap) {
            const lat = +collegeMap.dataset.lat
            const lon = +collegeMap.dataset.lon
            const coords = [lat, lon]
            const arr = JSON.parse(collegeMap.dataset.arr)
            const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'
            
            ymaps.ready(() => {
                const myMap = new ymaps.Map("collegeMap", {
                    center: coords ,
                    zoom: 12
                });

                arr.forEach(item => {
                    let cor = [item.lat, item.lon]
                    myMap.geoObjects				
                    .add(new ymaps.Placemark(cor , {
                        balloonContent: item.name
                    }, {
                        //preset: 'islands#blueEducationCircleIcon',
                        //iconColor: '#3b5998'
                        iconLayout: 'default#image',
                        iconImageHref: iconUrl,
                        iconImageSize: [36, 36],
                    }))
                })

                myMap.geoObjects				
				.add(new ymaps.Placemark(coords , {
					balloonContent: collegeMap.dataset.name
				}, {
					//preset: 'islands#blueEducationCircleIcon',
					//iconColor: '#3b5998'
                    iconLayout: 'default#image',
                    iconImageHref: iconUrl,
                    iconImageSize: [36, 36],
				}))
            })
        }

    }
}

export default Colleges

